import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "company-info",
  relative: ""
}
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "headline" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "actions",
  clickable: ""
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Skeleton = _resolveComponent("Skeleton")
  const _component_SaveDoc = _resolveComponent("SaveDoc")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_MdContent = _resolveComponent("MdContent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" IMAGE "),
      _createVNode(_component_Icon, {
        width: "4rem",
        height: "4rem",
        icon: "user-02"
      }),
      _createCommentVNode(" INFO "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createCommentVNode(" NAME "),
          _createElementVNode("div", _hoisted_5, [
            ($options.title)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  innerHTML: $options.title
                }, null, 8 /* PROPS */, _hoisted_6))
              : (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 1,
                  width: "100%",
                  height: "4rem"
                }))
          ]),
          _createCommentVNode(" ACTIONS "),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_SaveDoc, {
              disabled: $props.loading,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              onSave: _cache[1] || (_cache[1] = $event => (_ctx.$emit('save', $event)))
            }, null, 8 /* PROPS */, ["disabled"]),
            _createVNode(_component_Tooltip, { text: "Create prep podcast" }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "action-icon pointer",
                  icon: "podcast",
                  disabled: $props.loading,
                  hoverable: "",
                  "stroke-width": "1",
                  stroke: "var(--gray-600)",
                  width: "2rem",
                  height: "2rem",
                  onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.$dispatch('podcast-save')), ["stop"]))
                }, null, 8 /* PROPS */, ["disabled"])
              ]),
              _: 1 /* STABLE */
            })
          ])
        ])
      ])
    ]),
    _createCommentVNode(" DESCRIPTION "),
    ($options.summary)
      ? (_openBlock(), _createBlock(_component_MdContent, {
          key: 0,
          markdown: $options.summary,
          class: "bio"
        }, null, 8 /* PROPS */, ["markdown"]))
      : ($props.loading)
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 1,
            class: "bio",
            width: "100%",
            height: "2.4rem"
          }))
        : _createCommentVNode("v-if", true)
  ]))
}